import React from 'react'
import SignInForm from '../components/SignInForm'
import { Link } from 'react-router-dom'
import IkeaLogo from '../assets/IKEA_2018_h58.png'

const CognitoSignInPage = () => {
  return (
    <>
      <main className="content">
        <section className="box">
          <header className="brand">
            <div className="logo">
              <img src={IkeaLogo} alt="IKEA" style={{ width: '132px' }} />
            </div>
            <div className="box_messages">
              <h1>Sign in to Kontrollera</h1>
              <p className="byline">Welcome to KONTROLLERA Co:worker</p>
            </div>
          </header>
          <div className="box_forms">
            <SignInForm />
            <div>
              New to Kontrollera? <Link to={'./signup'}>Create a new account</Link>
            </div>
          </div>
        </section>
      </main>
      <style jsx global>{`
        html {
          font-size: 16px;
        }
        body {
          background-color: #0058ab;
          font-family: ulp-font, -apple-system, BlinkMacSystemFont, Roboto, Helvetica, sans-serif;
          font-weight: 400;
          -webkit-overflow-scrolling: touch;
          overflow: auto;
        }
        .App {
          display: grid;
          grid-template-columns: 1fr;
          grid-template-rows: 100vh;
          align-items: center;
          justify-items: center;
        }
        main {
          position: relative;
          font-size: 14px;
          color: #2d333a;
          background-color: #fff;
          box-shadow: 0 12px 40px rgb(0 0 0 / 12%);
          border-radius: 5px;
          border: 0 solid transparent;
        }
        section {
          position: relative;
          width: 400px;
        }
        header {
          padding: 40px 40px 0;
          line-height: 1.5;
          text-align: center;
          flex-shrink: 0;
        }
        h1 {
          font-size: 24px;
          font-weight: 400;
          letter-spacing: 0;
          color: #2d333a;
        }
        .logo img {
          display: block;
          margin: 0 auto;
        }
        .box_messages {
          padding: 0 40px 0;
          text-align: center;
          flex-shrink: 0;
        }
        .box_forms {
          padding: 0 40px 40px;
          text-align: center;
          flex-shrink: 0;
        }
        @media (max-width: 600px) {
          body {
            background-color: white;
          }
          main {
            min-height: 100%;
          }
          section {
            width: 100vw;
            justify-items: top;
            min-height: 100%;
            border-radius: 0;
            box-shadow: none;
          }
        }
      `}</style>
    </>
  )
}

export default CognitoSignInPage
